// extracted by mini-css-extract-plugin
export var articleImagesContainer = "ArticleImages-module--articleImagesContainer--0c9b4";
export var column1 = "ArticleImages-module--column1--39c62";
export var column2 = "ArticleImages-module--column2--e3e15";
export var imageCell = "ArticleImages-module--imageCell--945c2";
export var swiperContainer = "ArticleImages-module--swiperContainer--47e09";
export var swiperSlide = "ArticleImages-module--swiperSlide--879a9";